import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function ChemicalPeelsHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-390">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/kYnJ1rPAeEtUtrS9Qr1tJ9/chemical-peels-1.jpg)'
    }} data-id="element-391" />
      <div className="absolute inset-0 bg-black/50" data-id="element-392" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-393">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-394">
          <div className="mb-6" data-id="element-395">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-396">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-397">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-398">
            Be MESMERIZING
          </span>

          <h1 className="text-[36px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-399">
            CHEMICAL PEELS
          </h1>

          <div className="space-y-6" data-id="element-400">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-401">
              Chemical peels offer a highly effective way to rejuvenate the skin
              by addressing common concerns like dullness, fine lines, acne
              scars and sun damage. Patients can enjoy smoother, more radiant
              skin with long-lasting improvements and little to no downtime. At
              Be CLINICAL, we use safe, medical-grade chemical peel solutions
              and a personalized approach to meet each individual's specific
              skincare goals.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-402">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}